<template>
  <v-app id="inspire">

    <v-app-bar app dark color="primary">
    <!-- <v-app-bar app dark color="blue-grey darken-3"> -->
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <img width="65" src="@/assets/img/logo-login-nominus.jpg" alt="Vuetify.js" class="pa-2"> -->
      <v-toolbar-title>Dino Toys</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      bottom
    >
      <!-- <v-list-item style="background-color: #173578!important" dark color="blue-grey darken-3">
        <v-list-item-content>
          <v-list-item-title class="justify-center">
            <span>Dino Toys</span>
          </v-list-item-title>
          <v-list-item-subtitle class="justify-center">
            <span>v1.0.0</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->

      <v-list>
        <v-list-item class="justify-center">
          <v-avatar color="red" size="120">
            <v-icon dark size="120">
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ usuario.names }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ usuario.email }}</v-list-item-subtitle>
            <v-list-item-subtitle class="title" style="color: #173578 !important">Administrador</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list
        nav
        dense
      >

        <v-list-item-group
          v-model="group"
          color="primary"
        >
          <template v-for="acceso in menus">
            <v-subheader v-if="acceso.name != ''">{{ acceso.name }}</v-subheader>
            <template v-for="(item, i) in acceso.submenu">
              <v-list-item
                :key="item.name"
                :to="item.link"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title v-html="item.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>

          <!-- <br>
          <v-divider></v-divider>
          <v-list-item
            :key="100"
            class="v-item--active v-list-item--active"
            @click="installer()"
          >
            <v-list-item-icon>
              <v-icon>get_app</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Agregar Nominus v3.0 <br> a la pantalla principal</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout" dark color="primary">
            Salir
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <v-container fluid>
          <slot name="content"></slot>
        </v-container>
      </v-container>
    </v-main>

  </v-app>
</template>
<script>

  export default {
    name: 'DefaultLayout',
    data: () => ({
        drawer: true,
        group: null,

        usuario: {},
        menus: [],
        account: null,
        authorization: null,
        infoTrabajador: {},

        installer: undefined,
    }),
    created() {
      let installPrompt;

      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        installPrompt = e;
      });

      this.installer = () => {
        installPrompt.prompt();
        installPrompt.userChoice.then(result => {
          if (result.outcome === "accepted") {
            console.log("User accepted");
          } else {
            console.log("User denied");
          }
          installPrompt = null;
        });
      };
    },
    mounted: function () {
      this.usuario = JSON.parse(localStorage.getItem('user'));
      this.menus = JSON.parse(localStorage.getItem('menus'));
      this.authorization = localStorage.getItem('authorization');

      if (this.authorization == null || this.authorization == '') {
        this.logout();
      }
    },
    watch: {
      group () {
        this.drawer = true
      },
    },
    methods: {
      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue